// src/config.js
const testEndPoints = {
  baseUrl: 'https://ec2-13-236-121-79.ap-southeast-2.compute.amazonaws.com/api',
};
const devEndpoints = {
  baseUrl: 'http://127.0.0.1:5000/api',
};
const prodEndPoints = {
  baseUrl: 'https://watterson.media-monitor.com.au/api',
};
const diEndPoints = {
  baseUrl: 'https://media-monitor.diaus-genai-demo.com/api',
};

export const envEndPoints = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

  switch (env) {
    case 'development':
      return devEndpoints;

    case 'test':
      return testEndPoints;

    case 'production':
      return prodEndPoints;

    case 'di':
    case 'demo':
      return diEndPoints;

    default:
      // fallback so something always works locally
      return devEndpoints;
  }
};
